'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _isPlainObject2.default;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/isPlainObject.js
// module id = 1256
// module chunks = 0